import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { sortByGifts } from "@jti/commerce/shared";
import type { Product } from "@jti/magento";

import type { SummaryItem } from "../../ItemsSummaryView";
import { mapProductToSummaryItem } from "../../utils/mapProductToSummaryItem";

export const useProductsMappedToSummaryItems = (items: readonly Product[] | null = []) => {
  const {
    displayBundleSelectedItems,
    displayBundleSelectedItemsPrices,
    showPricesWithTaxExcluded = false,
  } = useConfig();

  const mappedItems = useMemo(() => {
    if (!items || items?.length === 0) {
      return [];
    }

    return [...items]
      .sort(sortByGifts)
      .map((cartItem: Product) =>
        mapProductToSummaryItem(cartItem, {
          isFreeTrial: false,
          displayBundleSelectedItems,
          displayBundleSelectedItemsPrices,
          showPricesWithTaxExcluded,
        })
      )
      .filter((item): item is SummaryItem => item !== null);
  }, [items, displayBundleSelectedItems, displayBundleSelectedItemsPrices, showPricesWithTaxExcluded]);

  return { summaryItems: mappedItems };
};
